import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  inject,
} from '@angular/core';

import { once } from '@web/utils';
import { HttpErrorService } from '@web/common';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { HttpErrorResponse } from '@angular/common/http';
import { WarehouseRestockDataSourceService } from '../../services/warehouse-restock-data-source.service';
import { WarehouseRestockFormData } from '../../models/warehouse-restock-form-data';
import { WarehouseRestockFormComponent } from '../../components/warehouse-restock-form/warehouse-restock-form.component';

@Component({
  selector: 'app-warehouse-restock-create',
  imports: [AlertsComponent, WarehouseRestockFormComponent],
  templateUrl: './warehouse-restock-create.component.html',
  styleUrl: './warehouse-restock-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class WarehouseRestockCreateComponent {
  /* prettier-ignore */
  private readonly warehouseRestockDataSource = inject(WarehouseRestockDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly fileUploadVisibility = input(false);
  public readonly submitSuccessEvent = output();

  public handleSubmitSuccessEvent(data: WarehouseRestockFormData): void {
    this.warehouseRestockDataSource
      .createByFormData(data)
      .pipe(once())
      .subscribe({
        next: () => {
          this.notifySubmitSuccessEvent();
        },
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    this.alerts.showMultiple((builder) =>
      this.httpError
        .extract(response)
        .messages()
        .map((message) => builder.buildFailure(message)),
    );
  }
}
